module.exports = __webpack_public_path__ + "img/3_Bericht_Wartung.c8619449.svg";